import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DecimalPipe } from '@angular/common';
import { ExtendedProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-double-readonly-field',
    templateUrl: '../simple-readonly-field/simple-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShDoubleReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent {
    // Injectors
    private readonly decimalTransform: DecimalPipe = inject(DecimalPipe);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedProfileField, record: PartialRecord): void {
        const value: string | null = this.decimalTransform.transform(
            this.fieldHelper.getDoubleFieldValue(profileField.FieldDefinition, record)
        );
        this.value$.next(value);
    }
}
